import { render } from "./promote.vue?vue&type=template&id=6b322b97&scoped=true"
import script from "./promote.vue?vue&type=script&lang=js"
export * from "./promote.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b322b97"]])

export default __exports__